import { ResolvedComponentsConfiguration } from "@zoovu/runner-browser-api";
import globals from "../partials/global-variables";
import stylesConfig from "../styles.config";
import mediaQuery from "../abstract/media-query";

const dropDownInputFontSize = stylesConfig.typography.fontSize();
const bordersColor = stylesConfig.colors.secondary.spectrum100;
const dropDownTextColor = stylesConfig.colors.primaryFontColor;
const dropDownHeadingColor = stylesConfig.colors.primaryFontColor;
const dropDownQuestionHeaderSize = {
  $lg: stylesConfig.typography.fontSize(1.3),
  $xs: stylesConfig.typography.fontSize(1.1),
};

export default {
  container: {
    "& .simplebar-offset": {
      width: "calc(100% + 20px)",
    },
    "& .option": {
      position: "relative",
      left: "-10px",
    },
    "& p": {
      color: dropDownHeadingColor,
      textAlign: "center",
      width: "100%",
      fontSize: dropDownQuestionHeaderSize.$lg,
      margin: [0, 0, "36px"],
      [`@media (${globals.breakpoints.$xs})`]: {
        fontSize: dropDownQuestionHeaderSize.$xs,
        margin: ["15px", 0, "5px"],
        fontWeight: 600,
      },
    },
    "& .select-input-wrapper": {
      margin: ["15px", "auto"],
      border: (configuration: ResolvedComponentsConfiguration): string => `1px solid ${bordersColor(configuration)}`,
      width: "100%",
      padding: ["5px", "10px", "5px", 0],
      display: "none",
    },
    "& select": {
      color: dropDownTextColor,
      width: "100%",
      background: "transparent",
      border: 0,
      fontSize: dropDownInputFontSize,
      height: "29px",
      padding: "5px",
      outline: 0,
    },

    // Custom Dropdown
    "& .custom-select-container.disabled": {
      opacity: 0.5,
    },

    "& .custom-select-wrapper": {
      width: "100%",
      backgroundColor: stylesConfig.colors.secondary.spectrum100,
      position: "relative",
      padding: "100px 20px",
      marginBottom: "25px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      "&:before": {
        content: "' '",
        position: "absolute",
        width: "100%",
        height: "100%",
        left: 0,
        top: 0,
        backgroundColor: "rgba(255, 255, 255, 0.6)",
      },
      [`@media (${globals.breakpoints.$sm})`]: {
        padding: "20px 0",
      },
      "& i": {
        zIndex: 2,
        display: "block",
        width: "35px",
        height: "35px",
        borderRadius: "50%",
        backgroundImage: (configuration: ResolvedComponentsConfiguration): string =>
          `${globals.customerSpriteTheme5(configuration)}`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "0px -65px",
        backgroundColor: stylesConfig.colors.primary.spectrum400,
        marginLeft: "17px",
        [`@media (${globals.breakpoints.$sm})`]: {
          marginLeft: "10px",
        },
      },
      "& .custom-select-container": {
        position: "relative",
        width: "300px",
        [`@media (${globals.breakpoints.$sm})`]: {
          width: "auto",
          minWidth: "220px",
        },
        "&.is-open": {
          "& .custom-select-answer": {
            "& .icon": {
              transform: "rotate(180deg)",
            },
          },
          "& .custom-select-panel": {
            opacity: 1,
            maxHeight: "177px",
            borderLeft: "2px solid",
            borderRight: "2px solid",
            borderBottom: "2px solid",
            borderColor: bordersColor,
            borderRadius: "0 0 25px 25px",
            padding: "25px 10px 0 15px",
            backgroundColor: stylesConfig.colors.secondary.spectrum100,
            "& .simplebar-track.simplebar-vertical": {
              top: "25px",
              bottom: "12.5px",
            },
          },
        },
      },
      "& .custom-select-answer": {
        display: "block",
        zIndex: 4,
        position: "relative",
        width: "100%",
        padding: "13px 15px",
        backgroundColor: stylesConfig.colors.secondary.spectrum100,
        cursor: "pointer",
        fontSize: stylesConfig.typography.fontSize(),
        fontWeight: 700,
        color: stylesConfig.colors.primaryFontColor,
        textAlign: "center",
        borderRadius: "25px",
        "& .icon": {
          background: (configuration: ResolvedComponentsConfiguration): string =>
            `${globals.customerSpriteTheme5(configuration)} no-repeat -48px -123px`,
          width: "12px",
          height: "7px",
          position: "absolute",
          right: "20px",
          top: "calc(50% - 4px)",
          transition: "all 0.3s ease",
        },
        "& .selected-answer-text": {
          display: "block",
          minHeight: "20px",
        },
      },
      "& .custom-select-panel": {
        opacity: 0,
        position: "absolute",
        marginTop: "-25px",
        paddingTop: "25px",
        zIndex: 3,
        top: "100%",
        left: 0,
        width: "100%",
        maxHeight: "0",
        transition: "all .3s ease-in-out",
        "& .option": {
          cursor: "pointer",
          fontSize: stylesConfig.typography.fontSize(1),
          fontWeight: 600,
          color: stylesConfig.colors.primaryFontColor,
          textAlign: "center",
          padding: "5px 15px 6px",
          position: "relative",
          "&:after": {
            content: "' '",
            position: "absolute",
            top: "-1px",
            left: "10%",
            width: "80%",
            height: "1px",
            backgroundColor: stylesConfig.colors.secondary.spectrum200,
          },
          [mediaQuery.hover]: {
            "&:hover": {
              backgroundColor: stylesConfig.colors.secondary.spectrum400,
              color: stylesConfig.colors.secondaryFontColor,
              "&:after": {
                backgroundColor: stylesConfig.colors.secondary.spectrum100,
              },
              "& +.option:after": {
                backgroundColor: stylesConfig.colors.secondary.spectrum400,
              },
            },
          },
        },
      },
      "&.selected": {
        "& .custom-select-answer": {
          color: stylesConfig.colors.primary.spectrum400,
        },
      },
      "& .custom-select-panel .option.option-disabled": {
        opacity: 0.5,
      },
    },
  },
};
